import React from 'react';
import SEO from '../components/SEO';
import BookHero from '../components/books/BookHero';
import BookItem from '../components/books/BookItem';
import { booksSchema, booksData } from '../data/booksData';

const Books = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Books by Laura Novak - Mystery & Comedy Fiction"
        description="Explore Laura Novak's novels: Finding Clarity and Murder at the Mailbox (Clari Drake mysteries), plus her upcoming Downtown LA comedy. Satire with a reporter's eye and comedian's timing."
        keywords="Laura Novak books, Clari Drake mystery series, Finding Clarity, Murder at the Mailbox, Berkeley mystery novels, Downtown LA comedy, California fiction"
        url="https://lauranovakwrites.com/books"
        ogImage="https://customer-assets.emergentagent.com/job_laura-nova-author/artifacts/4aprzk88_DTLAskyline.jpg"
        schema={booksSchema}
      />
      
      <BookHero />

      {/* Books Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="space-y-20">
            {booksData.map((book, index) => (
              <BookItem key={book.id} book={book} index={index} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Books;
